import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";

function EditTitle({ show, onHide, data, submitClick }) {
  const [val, setVal] = useState("");
  function handleShow() {
    setVal("");
  }
  return (
    <>
      <Modal show={show} onShow={handleShow} onHide={() => onHide()}>
        <ModalHeader closeButton>
          <h5 className="modal-title">Edit Training Title</h5>
        </ModalHeader>
        <ModalBody>
          <input type="text" onChange={(e) => setVal(e.target.value)} className="form-control" aria-describedby="Title Edit" defaultValue={data ? data.title : ""} />
        </ModalBody>
        <ModalFooter>
          <button onClick={() => submitClick({ id: data.id, label: "title", val: val })} type="button" className="btn btn-outline-theme" disabled={val ? false : true}>
            Save
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default EditTitle;
